import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { Reveal } from "../components/Reveal";
import { privacyPolicyDefault } from "../data/privacyPolicy";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PrivacyPolicy() {
  const [data, setData] = useState(privacyPolicyDefault);

  useEffect(() => {
    axios.get(`${API}/content/privacy_policy`).then((r) => {
      const v = r.data.value;
      if (v && typeof v === "object") {
        setData({
          title: v.title || privacyPolicyDefault.title,
          effective_date: v.effective_date || privacyPolicyDefault.effective_date,
          last_updated: v.last_updated || privacyPolicyDefault.last_updated,
          intro: v.intro || privacyPolicyDefault.intro,
          sections: Array.isArray(v.sections) && v.sections.length ? v.sections : privacyPolicyDefault.sections,
        });
      }
    }).catch(() => {});
  }, []);

  return (
    <div className="bg-white" data-testid="privacy-policy-page">
      <Helmet>
        <title>{`${data.title} | Superhost Cloud`}</title>
        <meta name="description" content="Privacy Policy for the Superhost App — how we collect, use, and protect your information." />
      </Helmet>

      <section className="relative pt-36 pb-12 lg:pb-16">
        <div className="absolute inset-0 bg-gradient-to-b from-[#F4F6FA] to-white" />
        <div className="absolute top-10 left-10 w-80 h-80 rounded-full bg-[#E84B1C]/10 blur-3xl" />
        <div className="relative max-w-3xl mx-auto px-5 lg:px-8">
          <Reveal>
            <span className="font-head text-[#E84B1C] font-semibold tracking-wide uppercase text-sm">Legal</span>
            <h1 className="mt-3 font-head font-extrabold leading-tight tracking-tight text-[#12284B] text-3xl sm:text-4xl lg:text-5xl">
              {data.title}
            </h1>
            <div className="mt-5 h-1.5 w-16 bg-[#E84B1C] rounded-full" />
            <div className="mt-5 flex flex-wrap gap-x-8 gap-y-1 text-sm text-black/60">
              <span><span className="font-semibold text-[#12284B]">Effective Date:</span> {data.effective_date}</span>
              <span><span className="font-semibold text-[#12284B]">Last Updated:</span> {data.last_updated}</span>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 lg:pb-28">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          {data.intro && (
            <Reveal>
              <p className="text-black/70 text-lg leading-relaxed">{data.intro}</p>
            </Reveal>
          )}

          <div className="mt-10 space-y-10">
            {data.sections.map((s, i) => (
              <Reveal key={i} delay={0.03}>
                <div>
                  <h2 className="font-head text-xl sm:text-2xl font-bold text-[#12284B] leading-snug">
                    {i + 1}. {s.heading}
                  </h2>
                  {String(s.body || "").split("\n").filter((p) => p.trim()).map((p, j) => (
                    <p key={j} className="mt-3 text-black/70 leading-relaxed">{p}</p>
                  ))}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
